import {
  BarsOutlined,
  RollbackOutlined,
  ShoppingCartOutlined,
  SkinOutlined,
} from '@ant-design/icons';
import { Badge, ConfigProvider } from 'antd';
import React from 'react';
import { StatBox } from '../../Analytics/EmailAnalytics/EmailSummaryStats';
import styles from './SignalStats.module.css';

const NoData = () => (
  <div className={styles.noData}>
    <div className={styles.badge}>
      <ConfigProvider
        theme={{
          components: {
            Badge: {
              dotSize: 8,
            },
          },
        }}
      >
        <Badge color="#1890FF" />
      </ConfigProvider>
    </div>
    <div>Will appear here</div>
  </div>
);
export const SignalStats = ({
  data,
}: {
  data: {
    productView: number | null;
    collectionView: number | null;
    addToCart: number | null;
    returnVisit: number | null;
  };
}) => (
  <div className={styles.statsContainer}>
    <div className={styles.title}>Analytics</div>
    <div className={styles.statsRow}>
      <StatBox
        className={styles.box}
        label="Product view"
        icon={<SkinOutlined className={styles.icon} />}
        stat={
          data?.productView === null ? (
            <NoData />
          ) : (
            (data?.productView || 0).toLocaleString()
          )
        }
      />
      <StatBox
        className={styles.box}
        label="Collection view"
        icon={<BarsOutlined className={styles.icon} />}
        stat={
          data?.collectionView === null ? (
            <NoData />
          ) : (
            (data?.collectionView || 0).toLocaleString()
          )
        }
      />
      <StatBox
        className={styles.box}
        label="Add to Cart"
        icon={<ShoppingCartOutlined className={styles.icon} />}
        stat={
          data?.addToCart === null ? (
            <NoData />
          ) : (
            (data?.addToCart || 0).toLocaleString()
          )
        }
      />
      <StatBox
        className={styles.box}
        label="Return visit"
        icon={<RollbackOutlined className={styles.icon} />}
        stat={
          data?.returnVisit === null ? (
            <NoData />
          ) : (
            (data?.returnVisit || 0).toLocaleString()
          )
        }
      />
    </div>
  </div>
);
